
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "40px",
    "height": "40px",
    "viewBox": "0 0 40 40",
    "enable-background": "new 0 0 40 40",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "fill": "#51565D",
            "d": "M40,31.488C40,36.17,36.17,40,31.489,40H8.511C3.83,40,0,36.17,0,31.488V8.512C0,3.83,3.83,0,8.511,0\r\n\t\th22.978C36.17,0,40,3.83,40,8.512V31.488z"
          }
        }
      ]
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#BBBBBB",
        "d": "M10.734,20.078v7.992c0,0.893,0.893,1.787,1.786,1.787h14.304c0.893,0,1.785-0.895,1.785-1.787v-7.992\r\n\tl-8.938-7.775L10.734,20.078z M22.354,22.709v4.469H16.99v-4.469c0-0.986,0.801-1.789,1.788-1.789h1.787\r\n\tC21.553,20.92,22.354,21.723,22.354,22.709z M32.127,19.41c-0.133,0.371-0.481,0.615-0.872,0.615h-1.341l-10.242-8.908L9.43,20.025\r\n\tH8.087c-0.39,0-0.738-0.244-0.872-0.615c-0.135-0.371-0.029-0.787,0.267-1.045l10.895-9.48c0.365-0.318,0.83-0.479,1.295-0.479\r\n\tc0.466,0,0.93,0.16,1.296,0.479l3.174,2.764v-1.457c0-0.492,0.398-0.891,0.894-0.891h0.894c0.495,0,0.896,0.398,0.896,0.891v3.791\r\n\tl5.037,4.383C32.157,18.623,32.264,19.039,32.127,19.41z"
      }
    }
  ]
})
    }
  